export class Team {
    public TeamId: number;
    public Fullname: string;
    public Nickname: string;
}


// WEBPACK FOOTER //
// ./src/entities/team.ts